// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"V_bz","view":"V_dk","slide":"V_bC","img":"V_dl","btn":"V_bg","right":"V_dm","indicators":"V_dn","indicator":"V_dp","active":"V_dq"};